<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Brand logo:</div>
      </div>
      <div class="row">
        <div class="col-12">
          <p-select
            #logosDropdown
            [options]="logos"
            [(ngModel)]="selectedLogo"
            optionLabel="label"
            optionValue="folder"
            [disabled]="disabled"
            [filter]="true"
            filterBy="label"
            [showClear]="true"
            [placeholder]="logoPlaceholder"
            [style]="{ width: '100%', zIndex: '3' }"
            [ngModelOptions]="{ standalone: true }"
            name="logosDropdown"
            resetFilterOnHide="true"
            scrollHeight="25rem"
            (onChange)="onChange($event.value ?? '', 'Logo')"
          >
            <!-- Both templates are needed: the closed dropdown renders
                 "selectedItem", the open panel renders "item". -->
            <ng-template pTemplate="selectedItem">
              <div class="logo-option" *ngIf="selectedLogoOption">
                <img class="logo-option-thumb" [src]="selectedLogoOption.path" alt="" />
                <span>{{ selectedLogoOption.label }}</span>
              </div>
            </ng-template>

            <ng-template let-logo pTemplate="item">
              <div class="logo-option logo-option-panel">
                <img class="logo-option-thumb" [src]="logo.path" alt="" />
                <span>{{ logo.label }}</span>
              </div>
            </ng-template>
          </p-select>
        </div>
      </div>
    </div>
  </div>
</main>
